import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Sparkles } from "lucide-react";

export default function BrandHeader({ shop, right = null, minimal = false }) {
  // Apply per-shop brand color via CSS custom property
  useEffect(() => {
    if (!shop?.brand_color) return;
    const root = document.documentElement;
    const prev = root.style.getPropertyValue("--shop-accent");
    root.style.setProperty("--shop-accent", shop.brand_color);
    return () => root.style.setProperty("--shop-accent", prev);
  }, [shop?.brand_color]);

  const accent = shop?.brand_color || "#E6C662";

  return (
    <header
      className={`relative z-10 w-full ${minimal ? "py-4" : "py-6"} px-5 md:px-10 flex items-center justify-between`}
    >
      <Link
        to={shop ? `/s/${shop.slug}` : "/"}
        className="flex items-center gap-3 group"
        data-testid="brand-header-home"
      >
        <div
          className="w-10 h-10 rounded-full bg-void border flex items-center justify-center overflow-hidden gold-glow"
          style={{ borderColor: `${accent}66` }}
        >
          {shop?.logo_url ? (
            <img src={shop.logo_url} alt={shop.name} className="w-full h-full object-cover" />
          ) : (
            <Sparkles className="w-4 h-4" strokeWidth={1.5} style={{ color: accent }} />
          )}
        </div>
        <div className="leading-tight">
          <div className="font-heading text-base md:text-lg text-white tracking-tight">
            {shop ? shop.name : "AIBox Global Queue"}
          </div>
          <div className="font-numbers text-[10px] tracking-[0.25em] uppercase text-white/40">
            {shop ? shop.tagline || "Premium Experience" : "Smart Queue Platform"}
          </div>
        </div>
      </Link>
      <div className="flex items-center gap-3">{right}</div>
    </header>
  );
}
